// Navbar.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useStrings } from './strings/StringsContext';
import './Navbar.css';

const Navbar = () => {
  const { search } = useLocation();
  const to = (path) => ({ pathname: path, search });

  const { strings, agentName } = useStrings();

  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (
        menuRef.current && !menuRef.current.contains(e.target) &&
        btnRef.current && !btnRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 768 && open) setOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [open]);

  const navbarBrand = strings?.navbar_brand || agentName || 'Agent';
  const navbarLinks = Array.isArray(strings?.navbar_links) ? strings.navbar_links : [];

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to={to('/healthcare')}>{navbarBrand}</Link>
      </div>

      <ul className="navbar-links">
        {navbarLinks.map((item, index) => (
          <li key={`${item.path}-${index}`}>
            <Link to={to(item.path)}>{item.label}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;